var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-sheet",
    { staticClass: "rounded-xl my-6 subscription-page-container" },
    [
      _c(
        "div",
        { staticClass: "scrolling-content" },
        [
          _c("v-container", { staticClass: "py-12 align-start" }, [
            _c(
              "div",
              {
                staticClass: "mx-auto",
                staticStyle: { width: "100%", "max-width": "1200px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-center mb-12 d-flex flex-column justify-center align-center",
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "blue--text font-weight-bold text-uppercase mb-2",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("PaymentPage.SubscriptionPlan.title"))
                        ),
                      ]
                    ),
                    _c(
                      "h2",
                      { staticClass: "text--primary text-h3 font-weight-bold" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("PaymentPage.SubscriptionPlan.subtitle")
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "text--secondary mt-4",
                        staticStyle: { "max-width": "600px", margin: "0 auto" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("PaymentPage.SubscriptionPlan.description")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "v-chip",
                      {
                        staticClass: "mt-4",
                        attrs: { outlined: "", color: "grey" },
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { left: "", small: "", color: "green" } },
                          [_vm._v("mdi-cash-sync")]
                        ),
                        _c("span", { staticClass: "text--secondary" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "PaymentPage.SubscriptionPlan.exchangeRate",
                                  {
                                    exchangeRate:
                                      _vm.exchangeRate.toLocaleString(),
                                  }
                                )
                              )
                            ),
                          ]),
                          _vm.exchangeRateDate
                            ? _c("span", { staticClass: "ml-1" }, [
                                _vm._v(
                                  "(" + _vm._s(_vm.exchangeRateDate) + ")"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "align-end" },
                  _vm._l(_vm.plans, function (plan) {
                    return _c(
                      "v-col",
                      {
                        key: plan.id,
                        staticClass: "d-flex flex-column",
                        attrs: { cols: "12", md: "3" },
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass:
                              "pa-6 rounded-lg transition-swing flex-grow-1",
                            class: {
                              "selected-card": _vm.selectedPlanId === plan.id,
                            },
                            attrs: {
                              outlined: "",
                              elevation: _vm.selectedPlanId === plan.id ? 8 : 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectPlan(plan.id)
                              },
                            },
                          },
                          [
                            _vm.selectedPlanId === plan.id
                              ? _c(
                                  "v-icon",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "15px",
                                      right: "15px",
                                    },
                                    attrs: { color: "blue" },
                                  },
                                  [_vm._v(" mdi-check-circle ")]
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "mb-4" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "text--primary text-h5 font-weight-bold",
                                },
                                [_vm._v(_vm._s(plan.name))]
                              ),
                              !plan.isEnterprise
                                ? _c("div", { staticClass: "mt-2" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--primary text-h4 font-weight-bold",
                                      },
                                      [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              plan.priceUsd.toLocaleString()
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--secondary text-body-2",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.SubscriptionPlan.perLicense"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text--secondary text-subtitle-2 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          " ≈ " +
                                            _vm._s(
                                              _vm.formatKrw(
                                                plan.priceUsd * _vm.exchangeRate
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-caption" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "PaymentPage.SubscriptionPlan.approxConverted"
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-caption text-grey-darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "PaymentPage.SubscriptionPlan.paymentPeriod",
                                                {
                                                  paymentPeriod:
                                                    plan.periodDays ?? 30,
                                                }
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-caption text-grey-darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          "Valid for " +
                                            _vm._s(plan.periodDays ?? 30) +
                                            " day(s)"
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("div", { staticClass: "mt-2" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--primary text-h4 font-weight-bold",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.SubscriptionPlan.contactUs"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                            ]),
                            _c("v-divider", { staticClass: "my-4" }),
                            _c(
                              "div",
                              {
                                staticClass: "blue--text font-weight-bold mb-4",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "blue",
                                      left: "",
                                      small: "",
                                    },
                                  },
                                  [_vm._v("mdi-factory")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "PaymentPage.SubscriptionPlan.equipmentLimit",
                                        { limit: plan.equipmentLimit }
                                      )
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1" },
                              [
                                _vm._l(plan.features, function (feature, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass:
                                        "d-flex align-center mb-3 text--secondary",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "blue",
                                            small: "",
                                            left: "",
                                          },
                                        },
                                        [_vm._v("mdi-check")]
                                      ),
                                      _vm._v(" " + _vm._s(feature) + " "),
                                    ],
                                    1
                                  )
                                }),
                                !plan.isEnterprise
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center mb-3 text--secondary",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "blue",
                                              small: "",
                                              left: "",
                                            },
                                          },
                                          [_vm._v("mdi-account-group")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "PaymentPage.SubscriptionPlan.baseUsers",
                                                { count: plan.includedUsers }
                                              )
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-6",
                                class:
                                  _vm.selectedPlanId === plan.id
                                    ? "white--text"
                                    : "",
                                attrs: {
                                  block: "",
                                  large: "",
                                  outlined: _vm.selectedPlanId !== plan.id,
                                  depressed: _vm.selectedPlanId === plan.id,
                                  color:
                                    _vm.selectedPlanId === plan.id
                                      ? "blue"
                                      : "grey darken-1",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedPlanId === plan.id
                                        ? _vm.$t(
                                            "PaymentPage.SubscriptionPlan.selected"
                                          )
                                        : _vm.$t(
                                            "PaymentPage.SubscriptionPlan.choosePlan",
                                            { planName: plan.name }
                                          )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
                _c("v-expand-transition", [
                  _vm.selectedPlanId && !_vm.isEnterpriseSelected
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-row",
                            { staticClass: "mt-12" },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "7" } },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "pa-6 rounded-lg",
                                      attrs: { outlined: "" },
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "text--primary text-h6 mb-6",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                color: "blue",
                                              },
                                            },
                                            [_vm._v("mdi-tune")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "PaymentPage.SubscriptionPlan.configureAddons"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-space-between pa-4 rounded",
                                          attrs: { color: "grey lighten-4" },
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--primary font-weight-bold text-subtitle-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "PaymentPage.SubscriptionPlan.circuitModule"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "PaymentPage.SubscriptionPlan.circuitDescription"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mr-4 text--primary font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          _vm.currentPlan
                                                            ?.circuitModulePriceUsd ??
                                                            0,
                                                          "USD"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("v-switch", {
                                                staticClass: "mt-0",
                                                attrs: {
                                                  inset: "",
                                                  color: "blue",
                                                  "hide-details": "",
                                                },
                                                model: {
                                                  value: _vm.includeCircuit,
                                                  callback: function ($$v) {
                                                    _vm.includeCircuit = $$v
                                                  },
                                                  expression: "includeCircuit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c("v-divider", { staticClass: "my-6" }),
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass: "pa-4 rounded",
                                          attrs: { color: "grey lighten-4" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-space-between mb-4",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text--primary font-weight-bold text-subtitle-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.additionalUsers"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text--secondary text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.additionalUsersDescription"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text--primary font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          _vm.currentPlan
                                                            ?.additionalUserPriceUsd ??
                                                            0,
                                                          "USD"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text--secondary font-weight-regular",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.perUser"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("v-slider", {
                                            attrs: {
                                              min: "0",
                                              max: "20",
                                              "thumb-label": "",
                                              color: "blue",
                                              "track-color": "grey lighten-2",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "thumb-label",
                                                  fn: function ({ value }) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(value) +
                                                          " "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2669007223
                                            ),
                                            model: {
                                              value: _vm.extraUsers,
                                              callback: function ($$v) {
                                                _vm.extraUsers = $$v
                                              },
                                              expression: "extraUsers",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-right text--secondary text-caption",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "PaymentPage.SubscriptionPlan.contactForEnterprise"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "5" } },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "pa-6 rounded-lg",
                                      attrs: { color: "blue", dark: "" },
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "white--text text-h6 mb-6",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "PaymentPage.SubscriptionPlan.orderSummary"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        {
                                          staticStyle: {
                                            background: "transparent",
                                          },
                                          attrs: { dense: "", dark: "" },
                                        },
                                        [
                                          _c("tbody", [
                                            _vm.currentPlan
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "px-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.basePlan",
                                                            {
                                                              planName:
                                                                _vm.currentPlan
                                                                  .name,
                                                            }
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right px-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.currentPlan
                                                              .priceUsd,
                                                            "USD"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.includeCircuit
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "px-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.circuitAddon"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right px-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatPrice(
                                                              _vm.currentPlan
                                                                ?.circuitModulePriceUsd ??
                                                                0,
                                                              "USD"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "px-2 pt-4 font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "PaymentPage.SubscriptionPlan.subtotalUsd"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-right px-2 pt-4 font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.subtotalUsd,
                                                        "USD"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "px-2 text-caption",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "PaymentPage.SubscriptionPlan.subtotalKrw"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-right px-2 text-subtitle-2",
                                                },
                                                [
                                                  _vm._v(
                                                    " ≈ " +
                                                      _vm._s(
                                                        _vm.formatKrw(
                                                          _vm.subtotalKrw
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "PaymentPage.SubscriptionPlan.approxConverted"
                                                            )
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _c("v-divider", {
                                        staticClass: "white my-4",
                                        staticStyle: { opacity: "0.4" },
                                      }),
                                      _c(
                                        "v-simple-table",
                                        {
                                          staticStyle: {
                                            background: "transparent",
                                          },
                                          attrs: { dense: "", dark: "" },
                                        },
                                        [
                                          _c("tbody", [
                                            _vm.extraUsers > 0
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "px-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PaymentPage.SubscriptionPlan.extraUsersCost",
                                                            {
                                                              count:
                                                                _vm.extraUsers,
                                                            }
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right px-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.extraUserCostUsd,
                                                            "USD"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.extraUsers > 0
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "px-3 text-caption",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "PaymentPage.SubscriptionPlan.extraUsersCostKrw",
                                                              {
                                                                count:
                                                                  _vm.extraUsers,
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-right px-2 text-subtitle-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ≈ " +
                                                          _vm._s(
                                                            _vm.formatKrw(
                                                              _vm.extraUserCostKrw
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "PaymentPage.SubscriptionPlan.approxConverted"
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { staticClass: "px-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "PaymentPage.SubscriptionPlan.includedUsers"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-right px-2",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.totalUsersCount
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "PaymentPage.SubscriptionPlan.totalAccounts"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-4 mt-6 rounded",
                                          attrs: {
                                            color: "blue darken-1",
                                            flat: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grey--text text--lighten-3 text-caption mb-1",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "PaymentPage.SubscriptionPlan.estimatedTotal"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-end justify-space-between",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-h4 font-weight-bold white--text",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          _vm.estimatedTotalUsd,
                                                          "USD"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "white--text text-subtitle-1 text-right",
                                                },
                                                [
                                                  _vm._v(
                                                    " ≈ " +
                                                      _vm._s(
                                                        _vm.formatKrw(
                                                          _vm.estimatedTotalKrw
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "PaymentPage.SubscriptionPlan.approxConverted"
                                                            )
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "blue--text text--darken-4 font-weight-bold mt-6",
                                          attrs: {
                                            disabled:
                                              !_vm.selectedPlanId ||
                                              _vm.isEnterpriseSelected,
                                            block: "",
                                            "x-large": "",
                                            color: "white",
                                          },
                                          on: { click: _vm.proceedToCheckout },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "PaymentPage.SubscriptionPlan.proceedToCheckout"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("v-expand-transition", [
                  _vm.isEnterpriseSelected
                    ? _c(
                        "div",
                        { staticClass: "mt-12" },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "pa-8 text-center rounded-lg",
                              attrs: { color: "blue lighten-5", flat: "" },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "blue", size: "64" } },
                                [_vm._v("mdi-handshake")]
                              ),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "blue--text text--darken-4 text-h4 mt-4",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "PaymentPage.SubscriptionPlan.enterpriseTitle"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("p", { staticClass: "text--secondary mt-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "PaymentPage.SubscriptionPlan.enterpriseDescription"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-4 px-12",
                                  attrs: {
                                    "x-large": "",
                                    color: "blue",
                                    dark: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "PaymentPage.SubscriptionPlan.contactSales"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "auth-layout-footer" },
            [_c("client-footer-component")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }